import React from 'react';
import AudioStream from './components/AudioStream';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>StreamWave</h1>
      <AudioStream />
    </div>
  );
}

export default App;
